import axios from 'axios'
import library from '../../../utils/Library'

export const deleteSessions = async (uuidDeviceSession) => {
  const URL = library.getBaseAPIUrl('sessions') + '/revokeSessionDeviceEAuth'

  return await axios.post(URL, {
    uuidDeviceSession
  })
}
